import CrudPage from "./CrudPage";

const fields = [
  { name: "name", label: "Name", required: true },
  { name: "role", label: "Role", required: true, placeholder: "e.g. Lead Programmer" },
  { name: "photo_url", label: "Photo", type: "image", span: "full" },
  { name: "bio", label: "Bio", type: "textarea", span: "full" },
  { name: "order_index", label: "Order Index", type: "number" },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "role", label: "Role" },
  { key: "order_index", label: "Order" },
];

export default function AdminTeam() {
  return (
    <CrudPage
      title="Team"
      endpoint="/team"
      fields={fields}
      columns={columns}
      testidPrefix="team"
      emptyDefaults={{ name: "", role: "", photo_url: "", bio: "", order_index: 0 }}
    />
  );
}
